<section class="pb-16 md:py-16 lg:py-20 lg:pb-28 px-4 md:px-0">
  <div
    class="shadow-2xl shadow-black/40 container overflow-hidden md:overflow-visible bg-gradient-to-tr from-main-500 to-main-700 text-white rounded-2xl md:rounded-4xl">
    <div class="md:px-12 lg:px-16 flex flex-col md:flex-row md:items-center gap-8 md:gap-16">
      <div class="pt-10 md:py-16 lg:py-20 md:flex-1">
        <h2 class="text-2xl sm:text-3xl md:text-4xl font-bold mb-4"
            [innerHTML]="'HOME.DOWNLOAD_APP.TITLE' | translate">
        </h2>
        <p class="mb-6 text-white/90 md:text-lg">
          {{ 'HOME.DOWNLOAD_APP.DESCRIPTION' | translate }}
        </p>
        <div class="flex items-center gap-2 md:gap-3">
          <a href="https://play.google.com/store/apps/details?id=com.lsahatech.braidsbook.androidxstartup"
             target="_blank" rel="noopener noreferrer"
             [attr.aria-label]="'HOME.DOWNLOAD_APP.GOOGLE_PLAY_ALT' | translate"
             class="flex focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-main-600 rounded">
            <img ngSrc="/images/badges/google-play-store-badge.png"
                 [alt]="'HOME.DOWNLOAD_APP.GOOGLE_PLAY_ALT' | translate"
                 width="270" height="80"
                 class="h-11 md:h-14 w-auto drop-shadow-lg transition-transform lg:hover:scale-105">
          </a>
          <a href="https://apps.apple.com/ca/app/braidsbook/id6748860477" target="_blank" rel="noopener noreferrer"
             [attr.aria-label]="'HOME.DOWNLOAD_APP.APP_STORE_ALT' | translate"
             class="flex focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-main-600 rounded">
            <img ngSrc="/images/badges/app-store-badge.svg" [alt]="'HOME.DOWNLOAD_APP.APP_STORE_ALT' | translate"
                 width="120" height="40"
                 class="h-11 md:h-14 w-auto drop-shadow-lg transition-transform lg:hover:scale-105">
          </a>
        </div>
      </div>
      <div class="flex-1 self-stretch flex items-center justify-center relative">
        <img ngSrc="/images/app-screens.webp" [alt]="'HOME.DOWNLOAD_APP.SCREENS_ALT' | translate" width="696"
             height="757"
             class="md:w-[450px] lg:w-[470px] md:absolute md:bottom-0 md:right-0">
      </div>
    </div>
  </div>
</section>
